export interface IValueContainable {
  value: any;
}

export function instanceOfIValueContainable(instance: any): instance is IValueContainable {
  return instance
      && (instance.value !== undefined);
}
